<div class="row row-header">
  <div class="col-md-11 col-sm-11">
    <h1 mat-dialog-title class="text-center ml115">Parameter Details</h1>
  </div>
  <div class="col-md-1 col-sm-1 nopadding">
    <a class="cancelBtn cancelBtnPos" (click)="onCancelClick()"></a>
  </div>
</div>

<div mat-dialog-content>
  <div class="row px-5 py-4 no-overflow">
    <div class="col-sm-12 pad-lr">
      <div class="row mb-2">
        <div class="col-sm-2">
          <label for="StartDate" class="form-label"><strong>Start Date:</strong></label>
        </div>
        <div class="col-sm-10">
          <label for="StartDate" class="form-label">{{data[0].StartDate}}</label>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-2">
          <label for="EndDate" class="form-label"><strong>End Date:</strong></label>
        </div>
        <div class="col-sm-10">
          <label for="EndDate" class="form-label">{{data[0].EndDate}}</label>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-2">
          <label for="Location" class="form-label"><strong>Location:</strong></label>
        </div>
        <div class="col-sm-10">
          <label for="Location" class="form-label wrd-brk">{{data[0].Location}}</label>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-2">
          <label for="TagIds" class="form-label"><strong>Tag Ids:</strong></label>
        </div>
        <div class="col-sm-10">
          <label for="TagIds" class="form-label wrd-brk">{{data[0].TagIds}}</label>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-2">
          <label for="onlyADL" class="form-label"><strong>Only ADL:</strong></label>
        </div>
        <div class="col-sm-10">
          <label for="onlyADL" class="form-label">{{data[0].onlyADL}}</label>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-2">
          <label for="useCase" class="form-label"><strong>Use Case:</strong></label>
        </div>
        <div class="col-sm-10">
          <label for="useCase" class="form-label">{{data[0].useCase}}</label>
        </div>
      </div>
    </div>
  </div>
</div>




